import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import Body from "./Body.js";
export var Body1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Body, _extends({
    ref: ref,
    level: 1
  }, props));
});
export var Body2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Body, _extends({
    ref: ref,
    level: 2
  }, props));
});